import { render } from "./About.vue?vue&type=template&id=edbbf302&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=edbbf302&lang=scss&scoped=true"

import exportComponent from "/Users/jorgecastanho/Documents/projects/Website-JCLda/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edbbf302"]])

export default __exports__